export default "__VITE_ASSET__C$ChNRXG__"